import { React, useState } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { HiReceiptTax } from "react-icons/hi";
import '../../App.css'
import DeductionComponentsTable from '../table-data/DeductionComponentsTable';
import Popup from '../Popup';
import AddEmpDeductionComponent from './AddEmpDeductionComponent';

function ViewDeductionComponents(props) {

  const [openPopup, setOpenPopup] = useState(false);
  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  const handleCloseModal = () => {
    setOpenPopup(false);
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "-40px", margin: "10px", padding: "30px", fontWeight: "500px" }}>
      <Paper elevation={0}>
        <Grid className="form-title" style={{ marginBottom: "-50px", marginTop: "-60px" }} container spacing={2}>
          <Grid item> <Typography variant="h5" color="#344D67" sx={{ textAlign: "center", textDecoration: "underline", margin: 5 }}>Deduction Components</Typography> </Grid>
          <Grid item> <HiReceiptTax style={{ marginLeft: "-50px" }} size="30px" color="#344D67" /> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: "30px" }}>

            <Stack display="flex" sx={{ alignItems: "flex-end" }}>
              <Button
                style={{ width: "200px" }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={() => setOpenPopup(true)}
                startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                sx={{
                  whiteSpace: "nowrap",
                  textTransform: "none"
                }}
              >
                Add New Component
              </Button>
            </Stack>

            <DeductionComponentsTable employeeID={props.employeeID} fetch_id={props.fetch_id} />




          </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddEmpDeductionComponent title="Add New Deduction Component" employeeID={props.employeeID} fetch_id={props.fetch_id} onCloseModal={handleCloseModal} />
          {/*<AddEmployeeForm/>
          <EmployeeSalaryForm/>
          <LeaveDataMaster/>*/}
        </Popup>

      </Paper>
    </Box>
  )
}

export default ViewDeductionComponents;
